import { GET_NATIONALITY_OPT } from "../../../config/realstar-api-config";
import axios from "../../axios/axios";

export const fetchNationalityOpt = async () => {

  try {
    const response = await axios.get(`${GET_NATIONALITY_OPT}`);
    
    if(response.status === 200)
    { return response.data.countries }
    else
    { return response }
    

  } catch (error) {
    console.error('Error fetching gst data:', error);
    throw error;
  }
};